import type { HTMLAttributes } from 'react';

// Vite raw import — SVG markup as a string so we can inline it and let
// `currentColor` paths inherit from the parent's text colour. Co-located
// with the component (rather than living under public/) so it's bundled
// into the JS and not also shipped as a redundant static asset.
import logoSvg from './dataset-search-logo.svg?raw';

import { cn } from '~lib/utils/style';

interface LogoProps extends HTMLAttributes<HTMLAnchorElement> {
  href?: string;
}

/** SENSCIENCE wordmark, sourced from senscience.ai. Inlined so it inherits
 * `text-*` colours via `fill: currentColor`. Used in the page header. */
function Logo({ className, href = '/', ...props }: LogoProps) {
  return (
    <a
      href={href}
      aria-label="SENSCIENCE"
      className={cn(
        'inline-flex items-center text-foreground transition-colors hover:text-primary',
        className,
      )}
      {...props}
    >
      <span
        // Inline SVG so currentColor reaches the embedded paths.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: logoSvg }}
        className="block h-7 w-auto [&>svg]:block [&>svg]:h-full [&>svg]:w-auto"
      />
    </a>
  );
}

export { Logo };
